import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        userData: null,
        userError: null,
        userLoading: false,
    },
    reducers: {
        setUserData: (state, { payload }) => {
            state.userData = payload;
        },
        setUserError: (state, { payload }) => {
            state.userError = payload;
        },
        setUserLoading: (state, { payload }) => {
            state.userLoading = payload;
        },
    }
});

export const { setUserData, setUserError, setUserLoading } = userSlice.actions;

export default userSlice.reducer;